// Copyright 2016 Sorama B.V.

import { IColorMap } from "services/ColorMap/IColorMap";

export abstract class IColorMapService {
    colorMaps: IColorMap[];

    abstract setDefaultColorMap(key: string, colormap: IColorMap): Promise<void>;

    abstract getDefaultColorMap(key: string): Promise<IColorMap>;
}
